import React from 'react';

import * as BoxC from './_ccbBoxC';
import * as TextC from './_ccbTextC';
import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';
import * as HdrC from './_ccmHdrC';
import * as LgnMailC from './_ccmLgnMailC';
import { a } from './_cmABT';
import * as _cr from './_cr';
import * as _csLcl from './_csLcl';
import { useNgnz } from './_csNgn';
import * as _ht from './_ht';
import * as _hm from './_hm';
import * as _gv from './_gv';

import * as icv from './icv';
import * as icvBaseM10Rz from './icvBaseM10Rz';

const $cz = {
  text: 'ホーム',
};

export const R = (pz: {
}) => {

  const _sNgnz = useNgnz();

  return (
    _cr.c(BoxC.N, {
      boxStlz: a(`dh/f dw/f fd/ccc`),
      boxClds: [

        _cr.c(TextC.N, {
          key: -10,
          text: '納付券販売管理システム',
          textStlz: a(`tb tc/${icv.cz.clr}6 ts/xxl`),
          boxStlz: a(`mb/3`),
        }),

        _cr.c(LgnMailC.R, {
          key: -20,
          abtz: {
            btnNextz: icv.abtz.btnNextz,
            btnBackz: icv.abtz.btnBackz,
            lblVclz: icv.abtz.lblVclz,
          },
          cz: {
            _20r_key: 1, // ドメイン未使用のため
            _10rt1100i: 10,
            atrCfm: async (__10z: _ht.dz) => {
              if (_hm.f(__10z._10rz)) {
// _hm.l(`icvLgnM10Rz 52:` + _hm.s(__10z));
                const _gUserz = _gv.useUserz();
                await _gUserz.saveAsync({
                  _20rz: {
                    _key: 1, // ドメイン未使用のため
                  }
                });
                _sNgnz.setPageName('icvHomeM10Rz');
              }
            }
          }
        })

      ]
    })

  )
};
